import Container from '@material-ui/core/Container';

import ConfidentTermBox from './ConfidentTermBox';


const ConfidentTerms = ({ handleClickTerms, clientPersonalData, isLoadingTermsButton, errorRequestTermsPage }) => {
    return (
        <Container>
            <div className="row">
                <div className="col-12">
                    <ConfidentTermBox
                        clientData={clientPersonalData}
                        handleClickTerms={handleClickTerms}
                        isLoadingTermsButton={isLoadingTermsButton}
                        errorRequestTermsPage={errorRequestTermsPage}
                    />
                </div>
            </div>
        </Container>
    );
};

export default ConfidentTerms;
